/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps, Module, Node, Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IDobbiesAddedProductToBundle, IProductCollectionViewProps, IProductComponentViewProps } from './dobbies-product-collection';
import { IDobbiesMiniCartSummaryProduct } from '../../themes/dobbies/views/buybox.view';
import MsDyn365 from '@msdyn365-commerce/core';
import { ProductPrice, SimpleProduct, ProjectionDomain, DeliveryOption, ProductDeliveryOptions } from '@msdyn365-commerce/retail-proxy';
import { CartModulesStateShareInput } from '../../actions/cart-state-share';
import { Quantity } from '../../themes/dobbies/utilities/quantity';
import { getCartState } from '@msdyn365-commerce/global-state';
import {
    getByIdsAsync,
    getDeliveryOptionsAsync,
    getActivePricesAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ArrayExtensions, QueryResultSettingsProxy } from '@msdyn365-commerce-modules/retail-actions';
import { cartLineQuantityUpdatedAsync } from '@msdyn365-commerce-modules/cart-utilities';
import { ICartActionResult } from '@msdyn365-commerce/global-state';
import * as Msdyn365 from '@msdyn365-commerce/core';
import PriceComponent from '../../themes/dobbies/views/custom-components/product-price-component';
import { IFullOrgUnitAvailability } from '../../themes/dobbies/actions/utilities/full-org-unit-availability';
import { GetAllOrgUnitLocationsByAreaInput, getAllOrgUnitLocationsByArea } from '../../actions/get-all-store-location-information';

const ProductCollectionView: React.FC<IProductCollectionViewProps> = props => {
    const [cartProducts, setCartProducts] = React.useState<IDobbiesMiniCartSummaryProduct[]>([]);
    const [bundlesSummaryScrollPos, setBundlesSummaryScrollPos] = React.useState(0);
    const [bundlesModalSummaryScrollPos, setBundlesModalSummaryScrollPos] = React.useState(0);

    const {
        heading,
        ProductCollectionContainer,
        products,
        SingleSlideCarouselComponentProps,
        GridComponentProps,
        isCarousel,
        pdpProduct,
        pdpProductComponent
    } = props;

    const equalsCheck = (a: number[], b: number[]) => {
        return a.length === b.length && a.every((v, i) => v === b[i]);
    };

    React.useEffect(() => {
        if (props.onStoreSelectorDialogClose && props.data.storeSelectorStateManager.result?.isDialogOpen === false) {
            props.onStoreSelectorDialogClose();
        }
    }, [props.data.storeSelectorStateManager.result?.isDialogOpen]);

    const renderStoreSelector = (
        product: SimpleProduct,
        quantity: number,
        retailMulitplePickupMFeatureState: boolean,
        deliveryOption: DeliveryOption,
        isFromModal: boolean,
        isFromNotification?: boolean
    ) => {
        //const cartState = await getCartState(props.context.actionContext);
        let storeSelectorId = '';
        if (
            props.modules &&
            Object.keys(props.modules).length > 0 &&
            props.modules.storeSelectors &&
            props.modules.storeSelectors.length > 0
        ) {
            storeSelectorId = props.modules.storeSelectors[0].id;
        }
        // storeSelectorId = props.data.storeSelectorStateManager.result?.context?.id || ''; // 'dobbies-buybox-store-selector'
        const productDeliveryOptions: ProductDeliveryOptions = { ProductId: product.RecordId, DeliveryOptions: [deliveryOption] };
        props.data.storeSelectorStateManager.result
            ?.openDialog({
                product,
                id: storeSelectorId,
                deliveryOptions: retailMulitplePickupMFeatureState ? productDeliveryOptions : undefined,
                isDialog: true,
                onLocationSelected: async (orgUnitLocation, deliveryMode) => {
                    const cartState = await getCartState(props.context.actionContext);
                    if (!cartState.cart) {
                        return Promise.resolve();
                    }

                    const {
                        context: {
                            app: { config }
                        }
                    } = props;
                    const behavior = config && config.addToCartBehavior;
                    if (isFromModal) {
                        return cartState
                            .addProductToCart({ product: product, count: quantity, location: orgUnitLocation, deliveryMode: deliveryMode })
                            .then(result => {
                                if (result.status === 'FAILED' && result.substatus === 'MAXQUANTITY') {
                                    console.log('Result failed');
                                    // callbacks.changeModalOpen(false);
                                    // const productAvailability = state.productAvailableQuantity
                                    //     ? state.productAvailableQuantity.ProductAvailableQuantity
                                    //     : productAvailableQuantity && productAvailableQuantity.length
                                    //     ? productAvailableQuantity[0].ProductAvailableQuantity
                                    //     : undefined
                                    // const failureResult: IAddToCartFailureResult = {
                                    //     failureReason: 'CARTACTIONFAILED',
                                    //     cartActionResult: { status: result.status, substatus: result.substatus }
                                    // };
                                    // callbacks.updateErrorState({
                                    //     errorHost: 'ADDTOCART',
                                    //     configureErrors: {},
                                    //     otherError: getGenericError(
                                    //         failureResult,
                                    //         cart,
                                    //         resources,
                                    //         context,
                                    //         product,
                                    //         productAvailability,
                                    //         orgUnitLocation
                                    //     )
                                    // });
                                } else {
                                    if (behavior === undefined || behavior === 'goToCart' || behavior === 'nothing') {
                                        if (result.status === 'SUCCESS') {
                                            // SetIsAddedToCart(true);
                                            // if (onAddToCartClicked) {
                                            //     onAddToCartClicked();
                                            // }
                                            props.context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                            if (props.onClickAndCollectSelectedToBeAddedInCookie) {
                                                props.onClickAndCollectSelectedToBeAddedInCookie(product.RecordId, orgUnitLocation, true);
                                            }
                                            // if (isFromNotification) {
                                            //     updateCartProduct();
                                            // }
                                        }
                                    } else if (behavior === 'showModal') {
                                        console.log('Show modal');
                                        // callbacks.updateErrorState({
                                        //     configureErrors: {}
                                        // });
                                        // callbacks.changeModalOpen(true);
                                    }
                                }
                            })
                            .catch((error: Error) => {
                                if (props.telemetry) {
                                    props.telemetry.exception(error);
                                    props.telemetry.debug('Unable to add product to cart');
                                }
                                return;
                            });
                    } else {
                        if (props.onClickAndCollectSelectedToBeAddedInCookie) {
                            props.onClickAndCollectSelectedToBeAddedInCookie(product.RecordId, orgUnitLocation);
                        }
                    }
                }
            })
            .catch((error: Error) => {
                if (props.telemetry) {
                    props.telemetry.error(error.message);
                    props.telemetry.debug('Unable to find in store');
                }
                return;
            });
    };
    const updateCartProduct = async () => {
        const productIds: number[] = props.data.cart.result?.cart.CartLines
            ? props.data.cart.result?.cart.CartLines?.map(cartline => cartline.ProductId || -1)
            : [];
        const cookies = props.context.actionContext.requestContext.cookies;
        const addedProducts =
            cookies.get(props.config.isNotificationModal ? 'notification_added_products' : 'added_products_bundles')?.value || [];
        if (Array.isArray(addedProducts)) {
            for (const ap of addedProducts) {
                if (!productIds.includes(ap['productId'])) {
                    productIds.push(ap['productId']);
                }
            }
        }
        const productBundleProducts = cookies.get('notification_products_for_summary');
        const updatedProductIds: number[] = [];
        if (Array.isArray(productIds)) {
            for (const prodId of productIds) {
                if (productBundleProducts && Array.isArray(productBundleProducts.value) && productBundleProducts.value['length'] > 0) {
                    for (const prodBP of productBundleProducts.value) {
                        if (+prodBP.itemId === prodId || `${+prodBP.itemId}` === `${prodId}`) {
                            updatedProductIds.push(prodId);
                        }
                    }
                }
            }
        }
        const simpleProductsData = ArrayExtensions.validValues(
            await getByIdsAsync(
                {
                    callerContext: props.context.actionContext,
                    queryResultSettings: QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(props.context.actionContext)
                },
                props.context.actionContext.requestContext.apiSettings.channelId
                    ? props.context.actionContext.requestContext.apiSettings.channelId
                    : -1,
                updatedProductIds,
                null,
                props.context.actionContext.requestContext.apiSettings.catalogId
            )
        );

        let simpleProductsWithQuantities = simpleProductsData.map(sp => {
            const prodWithQuantity: IDobbiesMiniCartSummaryProduct = { ...sp, quantity: 1 };
            const cl = props.data.cart.result?.cart.CartLines?.find(c => c.ProductId === prodWithQuantity.RecordId);
            if (Array.isArray(addedProducts)) {
                for (const ap of addedProducts) {
                    if (prodWithQuantity.RecordId === ap['productId']) {
                        prodWithQuantity.quantity = ap['quantity'];
                        if (cl && prodWithQuantity.quantity && cl.Quantity) {
                            prodWithQuantity.quantity += cl.Quantity;
                        }
                    }
                }
            }
            if (cl && cl.Quantity && prodWithQuantity.quantity && prodWithQuantity.quantity <= cl.Quantity) {
                prodWithQuantity.quantity = cl.Quantity;
            }
            return prodWithQuantity;
        });
        const simpleProdIds = simpleProductsWithQuantities.map(prod => prod.RecordId);
        const cartProductIds = cartProducts.map(cartProd => cartProd.RecordId);

        if (!equalsCheck(simpleProdIds, cartProductIds)) {
            const projectDomain: ProjectionDomain = {
                ChannelId: props.context.request.apiSettings.channelId,
                CatalogId: props.context.request.apiSettings.catalogId
            };
            const pIds = simpleProductsWithQuantities.map(p => p.RecordId);
            await getActivePricesAsync(
                {
                    callerContext: props.context.actionContext,
                    queryResultSettings: {}
                },
                projectDomain,
                pIds,
                new Date(),
                null,
                null,
                true
            )
                .then((activePricesResponse: ProductPrice[]) => {
                    if (activePricesResponse && activePricesResponse.length > 0) {
                        simpleProductsWithQuantities = simpleProductsWithQuantities.map(sp => {
                            const activePrice = activePricesResponse.find(price => price.ProductId === sp.RecordId);
                            if (activePrice) {
                                sp.Price = activePrice.CustomerContextualPrice ?? sp.Price;
                                sp.BasePrice = Math.max(
                                    activePrice.BasePrice || 0,
                                    activePrice.TradeAgreementPrice || 0,
                                    activePrice.AdjustedPrice || 0
                                );
                            }
                            return sp;
                        });
                    }
                })
                .catch((error: Error) => {});
            const updatedSimpleProductsWithQuantities = simpleProductsWithQuantities.filter(item => {
                // Check if product doesn't have inventory, dont dislay it
                const itemInventory = props.state.inventoryInformation.find(
                    inventory => inventory.ProductAvailableQuantity.ProductId === item.RecordId
                );
                const cncProducts = cookies.get('cnc_products').value || [];
                if (cncProducts && Array.isArray(cncProducts) && cncProducts.includes(item.ItemId)) {
                    return true;
                }
                return itemInventory && itemInventory.IsProductAvailable === true;
            });
            setCartProducts(updatedSimpleProductsWithQuantities);
        } else {
            if (simpleProductsWithQuantities) {
                let needsUpdate = false;
                for (const cp of cartProducts) {
                    const ap = simpleProductsWithQuantities.find(p => p.RecordId === cp.RecordId);
                    if (ap?.quantity !== cp.quantity) {
                        needsUpdate = true;
                    }
                }
                if (needsUpdate) {
                    const projectDomain: ProjectionDomain = {
                        ChannelId: props.context.request.apiSettings.channelId,
                        CatalogId: props.context.request.apiSettings.catalogId
                    };
                    const pIds = simpleProductsWithQuantities.map(p => p.RecordId);
                    await getActivePricesAsync(
                        {
                            callerContext: props.context.actionContext,
                            queryResultSettings: {}
                        },
                        projectDomain,
                        pIds,
                        new Date(),
                        null,
                        null,
                        true
                    )
                        .then((activePricesResponse: ProductPrice[]) => {
                            if (activePricesResponse && activePricesResponse.length > 0) {
                                simpleProductsWithQuantities = simpleProductsWithQuantities.map(sp => {
                                    const activePrice = activePricesResponse.find(price => price.ProductId === sp.RecordId);
                                    if (activePrice) {
                                        sp.Price = activePrice.CustomerContextualPrice ?? sp.Price;
                                        sp.BasePrice = Math.max(
                                            activePrice.BasePrice || 0,
                                            activePrice.TradeAgreementPrice || 0,
                                            activePrice.AdjustedPrice || 0
                                        );
                                    }
                                    return sp;
                                });
                            }
                        })
                        .catch((error: Error) => {});
                    const updatedSimpleProductsWithQuantities = simpleProductsWithQuantities.filter(item => {
                        // Check if product doesn't have inventory, dont dislay it
                        const itemInventory = props.state.inventoryInformation.find(
                            inventory => inventory.ProductAvailableQuantity.ProductId === item.RecordId
                        );

                        const cncProducts = cookies.get('cnc_products').value || [];
                        if (cncProducts && Array.isArray(cncProducts) && cncProducts.includes(item.ItemId)) {
                            return true;
                        }
                        return itemInventory && itemInventory.IsProductAvailable === true;
                    });
                    setCartProducts(updatedSimpleProductsWithQuantities);
                }
            }
        }
        props.context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: false });
    };
    React.useEffect(() => {
        updateCartProduct();
    }, [props.data.cart.result?.cart.CartLines]);
    React.useEffect(() => {
        if (props.data.cartSharedState?.result?.isCartUpdated) {
            updateCartProduct();
        }
    }, [props.data.cartSharedState.result?.isCartUpdated]);
    if (products) {
        if (props.config.isNotificationModal) {
            return (
                <>
                    <Module {...ProductCollectionContainer}>
                        {heading}
                        {isCarousel
                            ? _renderCarousel(SingleSlideCarouselComponentProps, products)
                            : _renderGrid(GridComponentProps, products)}

                        {props.shouldShowAddAllProducts && props.addAllProductsOnClick}
                    </Module>
                    <div className='price-summary-wrapper'>
                        <div className={`price-summary ${!props.data.cart.result?.cart.CartLines?.length ? 'empty' : ''}`}>
                            <h3>Your basket</h3>
                            {_renderCartLines(
                                props,
                                cartProducts,
                                setCartProducts,
                                bundlesSummaryScrollPos,
                                setBundlesSummaryScrollPos,
                                bundlesModalSummaryScrollPos,
                                setBundlesModalSummaryScrollPos,
                                true
                            )}
                            <Button
                                className='msc-add-to-cart'
                                disabled={!props.data.cart.result?.cart.CartLines?.length ? true : false}
                                title='Buy All'
                                onClick={() => {
                                    const notifiCheck = props.context.request.user.isAuthenticated ? 'signedin' : 'signedout';
                                    setCookie(props, 'notification_popup', notifiCheck, 1);
                                    MsDyn365.isBrowser && window && window.location.assign('/cart');
                                }}
                            >
                                {!props.data.cart.result?.cart.CartLines?.length ? 'Add an item' : 'View your basket'}
                            </Button>
                            <p>
                                {props.config.discountAppliedInCartMessage
                                    ? props.config.discountAppliedInCartMessage
                                    : 'Any offers/discounts will be applied at checkout'}
                            </p>
                        </div>
                    </div>
                    {props.storeSelectorDialogParams &&
                        renderStoreSelector(
                            props.storeSelectorDialogParams.product,
                            props.storeSelectorDialogParams.quantity,
                            props.storeSelectorDialogParams.retailMulitplePickupMFeatureState,
                            props.storeSelectorDialogParams.deliveryOption,
                            true,
                            true
                        )}
                    {props.storeSelectorDialogParams && props.slots.storeSelectors[0]}
                </>
            );
        } else if (pdpProduct && pdpProductComponent && !props.isBundlesModal) {
            return (
                <>
                    {pdpProductComponent}
                    <div className='plus'></div>
                    <Module {...ProductCollectionContainer}>
                        {heading}
                        {isCarousel
                            ? _renderCarousel(SingleSlideCarouselComponentProps, products)
                            : _renderGrid(GridComponentProps, products)}

                        {props.shouldShowAddAllProducts && props.addAllProductsOnClick}
                    </Module>
                    {props.storeSelectorDialogParams &&
                        renderStoreSelector(
                            props.storeSelectorDialogParams.product,
                            props.storeSelectorDialogParams.quantity,
                            props.storeSelectorDialogParams.retailMulitplePickupMFeatureState,
                            props.storeSelectorDialogParams.deliveryOption,
                            false
                        )}
                    {props.storeSelectorDialogParams && props.slots.storeSelectors[0]}
                </>
            );
        } else {
            return (
                <>
                    <Module {...ProductCollectionContainer}>
                        {heading}
                        {isCarousel
                            ? _renderCarousel(SingleSlideCarouselComponentProps, products)
                            : _renderGrid(GridComponentProps, products)}
                        {props.shouldShowAddAllProducts && props.addAllProductsOnClick}
                    </Module>
                    {props.storeSelectorDialogParams &&
                        renderStoreSelector(
                            props.storeSelectorDialogParams.product,
                            props.storeSelectorDialogParams.quantity,
                            props.storeSelectorDialogParams.retailMulitplePickupMFeatureState,
                            props.storeSelectorDialogParams.deliveryOption,
                            true
                        )}
                    {props.storeSelectorDialogParams && props.slots.storeSelectors[0]}
                </>
            );
        }
    }
    props.context.telemetry.error('Product collection content is empty, module wont render.');
    return null;
};

const setCookie = (props: IProductCollectionViewProps, name: string, value: string, deltaDaysFromToday: number) => {
    const { cookies } = props.context.request;
    const expirationDate = new Date(Date.now());
    expirationDate.setTime(expirationDate.getTime() + deltaDaysFromToday * 24 * 60 * 60 * 1000);

    cookies.set(name, value, {
        expires: deltaDaysFromToday ? expirationDate : null,
        isEssential: true
    } as {});
};

const _getAllStores = async (
    props: IProductCollectionViewProps,
    latitude?: number,
    longitude?: number,
    radius?: number,
    distanceUnitValue?: number
): Promise<IFullOrgUnitAvailability[]> => {
    const {
        context: { actionContext }
    } = props;

    const orgUnitLocationsInput = new GetAllOrgUnitLocationsByAreaInput(latitude, longitude, radius, distanceUnitValue, false);
    const orgUnitLocations = await getAllOrgUnitLocationsByArea(orgUnitLocationsInput, actionContext);
    return orgUnitLocations;
};

const changeQinBundlesModalSummary = async (
    props: IProductCollectionViewProps,
    productId: number,
    newValue: number,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    isSummaryInModal: boolean,
    maxQuantityForBundle: number
) => {
    const cartState = await getCartState(props.context.actionContext);
    const cl = cartState.cart.CartLines?.find(c => c.ProductId === productId);
    const simpleProduct: SimpleProduct | undefined = cartProducts.find(c => c.RecordId === productId);
    if (maxQuantityForBundle <= 0) {
        const cookies = props.context.actionContext.requestContext.cookies;
        const maxQuantities =
            cookies.get(
                props.config.isNotificationModal
                    ? 'product_notification_maximum_available_quantities'
                    : 'product_bundles_maximum_available_quantities'
            )?.value || [];
        if (Array.isArray(maxQuantities)) {
            for (const maxQ of maxQuantities) {
                if (maxQ.productId === productId) {
                    maxQuantityForBundle = maxQ.maxQuantity;
                    break;
                }
            }
        }
    }
    if (cl && cl.Quantity && maxQuantityForBundle && simpleProduct) {
        if (newValue > maxQuantityForBundle) {
            return;
        }
        const diffInQuantity = newValue - cl.Quantity;
        const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: props.context.actionContext, queryResultSettings: {} }, [
            productId
        ]);
        const emailDeliveryModeCode = props.context.actionContext.requestContext.channel?.EmailDeliveryModeCode;
        if (diffInQuantity > 0) {
            const addProductToCartInput = {
                product: simpleProduct,
                quantity: diffInQuantity,
                enableStockCheck: props.context.app.config.enableStockCheck,
                availableQuantity: maxQuantityForBundle,
                isAddEmailDeliveryItemToCart:
                    ArrayExtensions.hasElements(deliveryOptions) &&
                    ArrayExtensions.hasElements(deliveryOptions[0].DeliveryOptions) &&
                    deliveryOptions[0].DeliveryOptions[0].Code === emailDeliveryModeCode
            };
            const cookies = props.context.actionContext.requestContext.cookies;
            const cncProducts = cookies.get('cnc_products').value || [];
            if (Array.isArray(cncProducts) && cncProducts.includes(simpleProduct.ItemId)) {
                const deliveryOptions = await getDeliveryOptionsAsync(
                    { callerContext: props.context.actionContext, queryResultSettings: {} },
                    [simpleProduct.RecordId]
                );
                let cncOption: DeliveryOption | undefined;
                deliveryOptions.map(dopt => {
                    dopt.DeliveryOptions?.map(delOpt => {
                        if (delOpt.Code === 'ClickCol') {
                            cncOption = delOpt;
                        }
                    });
                });
                const sLocations = await _getAllStores(props, 31.5070767, 74.4315609, 0, 0);
                const storeLocation = sLocations.find(sl => {
                    return sl.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === cl.FulfillmentStoreId;
                });
                if (storeLocation && storeLocation.OrgUnitAvailability?.OrgUnitLocation) {
                    cartState
                        .addProductToCart({
                            product: simpleProduct,
                            count: diffInQuantity,
                            location: storeLocation.OrgUnitAvailability?.OrgUnitLocation,
                            deliveryMode: cncOption?.Code
                        })
                        .then(async result => {
                            if (result.status === 'SUCCESS') {
                                props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                            }
                        })
                        .catch(e => {});
                }
            } else {
                cartState
                    .addProductToCart(addProductToCartInput)
                    .then(async result => {
                        if (result.status === 'SUCCESS') {
                            props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                        }
                    })
                    .catch(e => {});
            }
        } else if (diffInQuantity < 0) {
            cartLineQuantityUpdatedAsync(true, cartState, props.context.actionContext.telemetry, [simpleProduct], cl, newValue)
                .then((cartActionResult: ICartActionResult | undefined): boolean => {
                    if (cartActionResult?.status === 'SUCCESS') {
                        props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                        return true;
                    }
                    return false;
                })
                .catch(e => {});
        }
    }
};
const onQuantityChange = async (
    props: IProductCollectionViewProps,
    productId: number,
    newValue: number,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    isSummaryInModal: boolean,
    maxQuantityForBundle: number
) => {
    if (isSummaryInModal) {
        changeQinBundlesModalSummary(props, productId, newValue, cartProducts, setCartProducts, isSummaryInModal, maxQuantityForBundle);
        return;
    }
    props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: false });
    const cookies = props.context.actionContext.requestContext.cookies;
    const addedProductsToCollection =
        cookies.get(props.config.isNotificationModal ? 'notification_added_products' : 'added_products_bundles')?.value || [];
    const cartProductsCopy = cartProducts.map(cp => cp);
    const updatedProducts: IDobbiesAddedProductToBundle[] = [];
    if (Array.isArray(addedProductsToCollection)) {
        for (const obj of addedProductsToCollection) {
            if (obj['productId'] === productId) {
                const valueToBeUpdated = newValue;
                if (valueToBeUpdated > 0) {
                    updatedProducts.push({
                        productId: obj['productId'],
                        price: obj['price'],
                        quantity: valueToBeUpdated,
                        maxQuantity: obj['maxQuantity']
                    });
                    for (const cp of cartProductsCopy) {
                        if (cp.RecordId === obj['productId']) {
                            cp.quantity = valueToBeUpdated;
                        }
                    }
                }
            } else {
                updatedProducts.push({
                    productId: obj['productId'],
                    price: obj['price'],
                    quantity: obj['quantity'],
                    maxQuantity: obj['maxQuantity']
                });
            }
        }
        const cookieName = props.config.isNotificationModal ? 'notification_added_products' : 'added_products_bundles';
        cookies.set(cookieName, updatedProducts);
        setCartProducts(cartProductsCopy);
        props.context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
    }
};
const _renderCartLines = (
    props: IProductCollectionViewProps,
    cartProducts: IDobbiesMiniCartSummaryProduct[],
    setCartProducts: React.Dispatch<React.SetStateAction<IDobbiesMiniCartSummaryProduct[]>>,
    bundlesSummaryScrollPos: number,
    setBundlesSummaryScrollPos: React.Dispatch<React.SetStateAction<number>>,
    bundlesModalSummaryScrollPos: number,
    setBundlesModalSummaryScrollPos: React.Dispatch<React.SetStateAction<number>>,
    isSummaryInModal: boolean
) => {
    let totalPrice = 0.0;
    const cookies = props.context.actionContext.requestContext.cookies;
    const productsAddedInBundles = cookies.get('notification_added_products')?.value || [];
    const elemId = 'notification_product_summary';
    const elem = MsDyn365.isBrowser && window && window.document.getElementById(elemId);
    const rowHeight = 116;
    const minProductsToScroll = isSummaryInModal && MsDyn365.isBrowser && window && window.innerWidth >= 1280 ? 2 : 1;
    const upArrowId = isSummaryInModal ? 'up-arrow-btn-modal' : 'up-arrow-btn';
    const downArrowId = isSummaryInModal ? 'down-arrow-btn-modal' : 'down-arrow-btn';
    let scrollPos = isSummaryInModal ? bundlesModalSummaryScrollPos : bundlesSummaryScrollPos;
    const rowHeightForCalc = 90;
    const maxQuantityReachedMsg = props.config.maxQuantityReachedInBundlesmsg
        ? props.config.maxQuantityReachedInBundlesmsg
        : `There is only 1 product left. Please choose quantity within the available range`;
    if (isSummaryInModal) {
        cartProducts = cartProducts.filter(cp =>
            props.data.cart.result?.cart.CartLines?.find(cl => cl.ProductId === cp.RecordId) ? true : false
        );
        if (cartProducts && props.data.cart.result?.cart.CartLines && props.data.cart.result?.cart.CartLines.length) {
            for (const c of props.data.cart.result?.cart.CartLines) {
                for (const cp of cartProducts) {
                    if (c.ProductId === cp.RecordId) {
                        cp.quantity = c.Quantity;
                    }
                }
            }
        }
    } else {
        cartProducts = cartProducts.filter(
            cp => Array.isArray(productsAddedInBundles) && productsAddedInBundles.find(p => p['productId'] === cp.RecordId)
        );
    }
    return (
        <>
            {cartProducts && cartProducts.length > minProductsToScroll ? (
                <Button
                    id={upArrowId}
                    onClick={() => {
                        if (elem) {
                            if (elem.scrollTop - rowHeight > 0) {
                                elem.scrollTop -= rowHeight;
                            } else {
                                elem.scrollTop = 0;
                            }
                            if (isSummaryInModal) {
                                setBundlesModalSummaryScrollPos(elem.scrollTop);
                            } else {
                                setBundlesSummaryScrollPos(elem.scrollTop);
                            }
                        }
                    }}
                    hidden={elem && scrollPos < 50 ? true : false}
                ></Button>
            ) : (
                <></>
            )}
            <div
                id={elemId}
                className='price-summary__product-list'
                onScroll={() => {
                    if (elem && Math.abs(Math.ceil(elem.scrollTop) - Math.ceil(scrollPos)) > rowHeightForCalc) {
                        if (!isSummaryInModal) {
                            if (elem.scrollTop >= (cartProducts.length - (minProductsToScroll + 1)) * rowHeightForCalc) {
                                setBundlesSummaryScrollPos(elem?.scrollTop);
                            } else if (elem.scrollTop < 50) {
                                setBundlesSummaryScrollPos(elem?.scrollTop);
                            }
                        } else {
                            if (elem.scrollTop >= (cartProducts.length - minProductsToScroll + 1) * rowHeightForCalc) {
                                setBundlesModalSummaryScrollPos(elem?.scrollTop);
                            } else if (elem.scrollTop < 50) {
                                setBundlesModalSummaryScrollPos(elem?.scrollTop);
                            }
                            const upArrow = MsDyn365.isBrowser && window && window.document.getElementById(upArrowId);
                            const downArrow = MsDyn365.isBrowser && window && window.document.getElementById(downArrowId);

                            if (elem.scrollTop < 50) {
                                if (upArrow) {
                                    upArrow.hidden = true;
                                }
                            } else {
                                if (upArrow) {
                                    upArrow.hidden = false;
                                }
                            }
                            if (elem.scrollTop > (cartProducts.length - minProductsToScroll) * rowHeightForCalc) {
                                if (downArrow) {
                                    downArrow.hidden = true;
                                }
                            } else {
                                if (downArrow) {
                                    downArrow.hidden = false;
                                }
                            }
                        }
                        scrollPos = elem.scrollTop;
                    }
                }}
            >
                {cartProducts.map((product, index) => {
                    let prodInBundles;
                    let cookiePrice;
                    let maxQuantityForBundle = 0;
                    let shouldShowQuantityReachedErrorMsg = false;
                    const cl = props.data.cart?.result?.cart.CartLines?.find(c => c.ProductId === product.RecordId);
                    if (Array.isArray(productsAddedInBundles)) {
                        prodInBundles = productsAddedInBundles.find(p => p['productId'] === product.RecordId);
                        if (prodInBundles) {
                            cookiePrice = prodInBundles['price'];
                            maxQuantityForBundle = prodInBundles['maxQuantity'];
                            if (!isSummaryInModal) {
                                product.quantity = prodInBundles['quantity'];
                                if (cl && cl.Quantity && product.quantity && maxQuantityForBundle) {
                                    shouldShowQuantityReachedErrorMsg = product.quantity + cl.Quantity > maxQuantityForBundle;
                                }
                            }
                        }
                    }
                    if (maxQuantityForBundle <= 0) {
                        const cookies = props.context.actionContext.requestContext.cookies;
                        const maxQuantities =
                            cookies.get(
                                props.config.isNotificationModal
                                    ? 'product_notification_maximum_available_quantities'
                                    : 'product_bundles_maximum_available_quantities'
                            )?.value || [];
                        if (Array.isArray(maxQuantities)) {
                            for (const maxQ of maxQuantities) {
                                if (maxQ.productId === product.RecordId) {
                                    maxQuantityForBundle = maxQ.maxQuantity;
                                    break;
                                }
                            }
                        }
                    }
                    if (product.quantity && product.quantity >= maxQuantityForBundle) {
                        shouldShowQuantityReachedErrorMsg = true;
                    }
                    const priceObj: ProductPrice = {
                        BasePrice: product.BasePrice,
                        AdjustedPrice: cookiePrice ? cookiePrice : product.Price,
                        CustomerContextualPrice: cookiePrice ? cookiePrice : product.Price
                    };
                    totalPrice =
                        totalPrice + (cookiePrice ? Number(cookiePrice) : product.Price) * (product.quantity ? product.quantity : 0);
                    const imageSettings = {
                        viewports: {
                            xs: { q: 'w=80&h=94&m=6', w: 0, h: 0 },
                            sm: { q: 'w=148&h=174&m=6', w: 0, h: 0 },
                            lg: { q: 'w=148&h=174&m=6', w: 0, h: 0 }
                        },
                        lazyload: true
                    };
                    const baseImageUrl: string = props.context.request.apiSettings.baseImageUrl;
                    <div></div>;
                    const currQ = product.quantity;
                    return (
                        <>
                            <div className='position-relative price-summary__product'>
                                <div className='price-summary__content'>
                                    <div className='msc-cart-line__product-image'>
                                        <Msdyn365.Image
                                            src={`${baseImageUrl}${product.PrimaryImageUrl}` || ''}
                                            fallBackSrc={''}
                                            product-bundle-container
                                            altText={product.Name}
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={imageSettings}
                                            loadFailureBehavior='empty'
                                        />
                                    </div>
                                    <div>
                                        <p className='product-name' title={product && product.Name}>
                                            {product && product.Name}
                                        </p>
                                        <PriceComponent
                                            context={props.context}
                                            id={'dobbies-product-collection'}
                                            typeName={'dobbies-product-collection'}
                                            data={{ price: priceObj }}
                                            savingsText={undefined}
                                            freePriceText={'Free'}
                                            originalPriceText={'Original price'}
                                            discountLine={undefined}
                                            updatedPrice={cookiePrice ? cookiePrice : product.Price}
                                            getTierId={undefined}
                                            clubPlusDiscountsOfferId={undefined}
                                        />
                                        {/* <p className='product-quantity'>Quantity: {product.quantity}</p> */}
                                        <p className='product-quantity'>Quantity: </p>
                                        <Quantity
                                            id={`msc-cart-line__quantity_${product.RecordId}`}
                                            currentCount={currQ}
                                            onChange={(newVal: number) => {
                                                onQuantityChange(
                                                    props,
                                                    product.RecordId,
                                                    newVal,
                                                    cartProducts,
                                                    setCartProducts,
                                                    isSummaryInModal,
                                                    maxQuantityForBundle
                                                );
                                            }}
                                            hideQuantityControls={false}
                                            disabledInput={false}
                                            max={maxQuantityForBundle}
                                            min={1}
                                        />
                                        {shouldShowQuantityReachedErrorMsg && <p className='quantity-error-msg'>{maxQuantityReachedMsg}</p>}
                                    </div>
                                </div>
                                <Button
                                    className='product-remove'
                                    onClick={() => {
                                        if (!isSummaryInModal) {
                                            const cookies = props.context.actionContext.requestContext.cookies;
                                            const productsAddedInBundles =
                                                cookies.get(
                                                    props.config.isNotificationModal
                                                        ? 'notification_added_products'
                                                        : 'added_products_bundles'
                                                )?.value || [];
                                            if (Array.isArray(productsAddedInBundles)) {
                                                for (let i = 0; i < productsAddedInBundles.length; i++) {
                                                    if (productsAddedInBundles[i]['productId'] === product.RecordId) {
                                                        delete productsAddedInBundles[i];
                                                    }
                                                }
                                                const updatedProductsAddedInBundles: IDobbiesAddedProductToBundle[] = [];
                                                productsAddedInBundles.map(prod => {
                                                    if (prod && prod['productId']) {
                                                        const dobbiesProductData: IDobbiesAddedProductToBundle = {};
                                                        dobbiesProductData.productId = prod['productId'];
                                                        dobbiesProductData.quantity = prod['quantity'];
                                                        dobbiesProductData.price = prod['price'];
                                                        dobbiesProductData.maxQuantity = prod['maxQuantity'];
                                                        updatedProductsAddedInBundles.push(dobbiesProductData);
                                                    }
                                                });
                                                const cookieName = props.config.isNotificationModal
                                                    ? 'notification_added_products'
                                                    : 'added_products_bundles';
                                                cookies.set(cookieName, updatedProductsAddedInBundles);
                                                props.context.actionContext.update(new CartModulesStateShareInput(), {
                                                    isCartUpdated: true
                                                });
                                            }
                                            return;
                                        }
                                        const cartlineToRemove = props.data.cart.result?.cart.CartLines?.find(
                                            cl => cl.ProductId === product.RecordId
                                        );
                                        if (cartlineToRemove) {
                                            const input = {
                                                cartLineIds: [cartlineToRemove.LineId!.toString()]
                                            };
                                            props.data.cart.result
                                                ?.removeCartLines(input)
                                                .then(() => {
                                                    props.context.actionContext.update(new CartModulesStateShareInput(), {
                                                        isCartUpdated: true
                                                    });
                                                })
                                                .catch(error => {
                                                    props.telemetry.warning(error);
                                                    props.telemetry.debug('Unable to Remove Cart Line');
                                                });
                                        } else {
                                            props.context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                        }
                                    }}
                                ></Button>
                            </div>
                        </>
                    );
                })}
            </div>

            {cartProducts && cartProducts.length > minProductsToScroll ? (
                <Button
                    id={downArrowId}
                    onClick={() => {
                        if (elem) {
                            elem.scrollTop += rowHeight;
                            if (isSummaryInModal) {
                                setBundlesModalSummaryScrollPos(elem.scrollTop);
                            } else {
                                setBundlesSummaryScrollPos(elem.scrollTop);
                            }
                        }
                    }}
                    hidden={elem && scrollPos > (cartProducts.length - minProductsToScroll) * rowHeightForCalc ? true : false}
                ></Button>
            ) : (
                <></>
            )}
            <p className='price-summary__total-price'>
                {'Total price:'}
                <span>
                    {' '}
                    {new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currencyDisplay: 'symbol',
                        currency: 'GBP',
                        minimumFractionDigits: 2
                    }).format(totalPrice)}
                </span>
            </p>
        </>
    );
};
const _renderCarousel = (carouselContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...carouselContainer}>{items && items.map(_renderProduct)}</Node>;
};

const _renderGrid = (gridContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...gridContainer}>{items && items.map(_renderProduct)}</Node>;
};

const _renderProduct = (product: IProductComponentViewProps): JSX.Element => {
    const { ProductContainer, productComponent, addToCartButton } = product;

    return (
        <Node {...ProductContainer}>
            {productComponent}
            {addToCartButton}
        </Node>
    );
};

export default ProductCollectionView;
